/**
 * InsightsCard — Card com até 6 insights operacionais automáticos
 */
import { AlertTriangle, Info, AlertCircle, CheckCircle } from "lucide-react";

export interface Insight {
  id?: string;
  tipo: string;
  titulo: string;
  descricao: string;
  severity: "info" | "warning" | "critical" | "success";
  acao?: string;
  metrica?: number;
}

interface InsightsCardProps {
  insights: Insight[];
  title?: string;
}

const SEVERITY_CONFIG = {
  info: { icon: Info, bg: "bg-blue-50", border: "border-blue-200", text: "text-blue-700", iconColor: "text-blue-500" },
  warning: { icon: AlertTriangle, bg: "bg-amber-50", border: "border-amber-200", text: "text-amber-700", iconColor: "text-amber-500" },
  critical: { icon: AlertCircle, bg: "bg-red-50", border: "border-red-200", text: "text-red-700", iconColor: "text-red-500" },
  success: { icon: CheckCircle, bg: "bg-green-50", border: "border-green-200", text: "text-green-700", iconColor: "text-green-500" },
};

export default function InsightsCard({ insights, title = "Insights Operacionais" }: InsightsCardProps) {
  if (!insights || insights.length === 0) {
    return (
      <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
        <div className="flex items-center gap-2">
          <Info className="text-green-500" size={18} />
          <p className="text-sm text-green-700 font-medium">Nenhum alerta no momento. Tudo operando normalmente.</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h3 className="text-sm font-semibold text-[#002F59] mb-3">{title}</h3>
      <div className="space-y-2">
        {insights.map((insight, i) => {
          const config = SEVERITY_CONFIG[insight.severity] || SEVERITY_CONFIG.info;
          const Icon = config.icon;
          return (
            <div key={insight.id || i} className={`p-3 rounded-lg border ${config.bg} ${config.border}`}>
              <div className="flex items-start gap-2">
                <Icon className={`${config.iconColor} mt-0.5 shrink-0`} size={16} />
                <div>
                  <p className={`text-sm font-medium ${config.text}`}>{insight.titulo}</p>
                  <p className="text-xs text-muted-foreground mt-0.5">{insight.descricao}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
